import styled from 'styled-components';
import { Spacing } from '@web/atomic';

export const EmojiTitleDescriptionStyled = styled.div`
  & + & {
    margin-top: ${Spacing.Large};
  }
`;
